var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13473",
    "data-name": "Group 13473",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2958",
    "data-name": "Rectangle 2958",
    width: 20,
    height: 16,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13472",
    "data-name": "Group 13472",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12987",
    "data-name": "Path 12987",
    d: "M10.294.072a.636.636,0,0,0-.588,0L.331,4.995a.612.612,0,0,0,0,1.086L3.987,8,.332,9.919A.611.611,0,0,0,.332,11l9.375,4.924a.636.636,0,0,0,.588,0L19.67,11a.611.611,0,0,0,0-1.085L16.018,8l3.651-1.919a.612.612,0,0,0,.257-.833.632.632,0,0,0-.257-.253ZM14.69,8.7l3.36,1.764L10,14.687,1.954,10.461,5.314,8.7,9.71,11a.63.63,0,0,0,.588,0ZM10,9.764,1.954,5.538,10,1.312,18.05,5.538Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/clone.bcaaa2bcf0519303fe4cce5d476eaad6.svg";
export { ForwardRef as ReactComponent };